(ns practitest.frontend.common.i18n
  (:require
    [clojure.string :as string]
    [practitest.frontend.common.utils :refer [in-dev-mode?]]
    [re-frame.core :as re-frame]))

;; Simplest possible locale implementation
(defonce locale-holder (atom {}))

;; Structure
{"en" {"key-id" "Hello"}
 "jp" {"key-id" "こにちわ"}}

(defn append-translation!
  [locale strings]
  (swap! locale-holder
         update locale merge strings))

(def default-locale "en")

;; Keep track of used IDs
;; TODO: disable in production
;; I'm using this to check for required translation strings in REPL
(defonce ^:private used-ids (atom {}))

(comment
  (doseq [[k v] (into (sorted-map)
                      (remove
                        (fn [[k v]]
                          (contains? (get @locale-holder default-locale) k)))
                      @used-ids)]
    (println (str (pr-str k)
                  ": "
                  "_("
                  (pr-str v)
                  ")"
                  ","))))

;; TODO: integration with linguiJS
;; TODO: macro with additional logic ?
(defn get-translation
  [id default]
  (swap! used-ids assoc id default)

  ;; TODO: remove re-frame dependency
  (let [locale (or @(re-frame/subscribe [:practitest.frontend.subs/current-locale])
                   default-locale)
        result (or (get-in @locale-holder [locale id])
                   (if (in-dev-mode?)
                     id
                     default))]
    result))

(defn format-translation
  "Well, poor man's support for string interpolation in localized strings
   Used currently the same syntax as in Rails:
   `\"'%{file-name}\" will be deleted permanently.`"
  [format-str & {:as params}]
  (string/replace format-str #"(?:%\{([\w\d\_\-]+)\})"
                  (fn [[full-match var-name]]
                    (get params (keyword var-name) full-match))))

(defn translation-fn [translations]
  (letfn [(t
            ([ref]
             (t ref {}))
            ([ref params]
             (when-let [default (translations ref)]
               (format-translation (get-translation ref default) params))))]
    t))

(comment

  (format-translation "\"%{file-name}\" will be deleted permanently."
                      :file-name "foobar.png")
  (format-translation "\"%{file-name}\" will be deleted permanently."
                      :file-name1 "foobar.png")
  (format-translation "no vars" :something "something")
  (format-translation "no vars no params"))

;; Implementation ideas
(comment
  ;; TODO: actual implementation
  ;; TODO: format support
  ;;xgettext -L Lisp -k -kptr:1c,2 -ktr -ktrid -ktrc -kntr:1,2 src/cljs/practitest/frontend/testset/add_instance.cljs

  ;; gettext
  (defn tr
    [msgid]
    msgid)

  (defn trid
    [msgid
     default
     params]
    msgid)

  (defn trc
    [msgid
     params
     components]
    msgid)

  ;; https://www.gnu.org/software/gettext/manual/html_node/Contexts.html
  ;; pgettext
  (defn ptr
    [msgctxt msgid]
    msgid)

  ;; https://www.gnu.org/software/gettext/manual/html_node/Plural-forms.html
  ;; ngettext
  (defn ntr
    [msgid plural]
    msgid)

  ;; PO file is translated to this format
  (comment
    #js {"msgid"              "Message text"

         ;; Context
         "msgctxt\u0004msgid" "Message text with context"

         ;; Plural
         "msgid2"             #js ["Plural 0"
                                   "Plural 1"
                                   "Plural 2"
                                   "Plural 3"]}

    (tr "")

    (itr
     "add-instances.rows-for-view"
     "{rows, plural,
           =0 {No data found}
           one {One row found}
           other {Showing data}} for <0>{viewname, select, undefined {default view}}</0>"
     #js {:rows       1
          ;; TODO: remove if nil value
          :viewname   "foo"
          :components #js [(fn [body]
                             [:strong body])]})

    ;; Will emit:
    (process-reagent-components (.message (.currentLocale global)
                                          "add-instances.rows-for-view"
                                          #js {:rows     1
                                               :viewname "foo"})
                                [(fn [body]
                                   [:strong body])])

    ;; And in the end
    [:*
     "No data found for "
     [:strong "default view"]]))
